import { Box, Divider, Typography } from '@mui/material'
import { ArrowLeft } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { theme } from 'utils/conf/theme'

export const Header = () => {
  const navigate = useNavigate()

  const onClickBack = () => {
    navigate(-1)
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          py: '1rem',
          gap: '2.5rem',
        }}
      >
        <Box
          onClick={onClickBack}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '2.5rem',
            height: '2.5rem',
            cursor: 'pointer',
          }}
        >
          <ArrowLeft size={'1.25rem'} color={theme.palette.primary.main} />
        </Box>

        <Typography variant="h2" sx={{ color: '#030712' }}>
          Create booking
        </Typography>
      </Box>

      <Divider sx={{ marginLeft: -16, marginRight: -16 }} />
    </>
  )
}
